module.exports = function mod(number, modulo) {
	var remain = number % modulo;
	return Math.floor(remain >= 0 ? remain : remain + modulo);
};



// WEBPACK FOOTER //
// ./node_modules/es-abstract/helpers/mod.js